// src/components/MetaTags.js
import { Helmet } from "react-helmet";

const MetaTags = ({
  title = "Originality — Fashion Manufacture & Private Label",
  description = "Originality adalah fashion manufacture di Pati, Jawa Tengah. Layanan produksi custom dan private label untuk T-Shirt, Hoodie, Sweater, dan lain-lain dengan kualitas tinggi.",
  url = window?.location?.href || "./",
  image = "/assets/img/favicon.png",
}) => {
  return (
    <Helmet>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta
        name="keywords"
        content="Originality, fashion manufacture, private label, sablon, bordir, T-Shirt, hoodie"
      />

      {/* Canonical */}
      <link rel="canonical" href={url} />

      {/* Hreflang */}
      <link rel="alternate" hrefLang="id" href={url} />
      <link rel="alternate" hrefLang="x-default" href={url} />

      {/* Robots */}
      <meta name="robots" content="index, follow" />

      {/* Favicons */}
      <link href="/assets/img/favicon.png" rel="icon" />
      <link href="/assets/img/apple-touch-icon.png" rel="apple-touch-icon" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Structured data (JSON-LD) */}
      <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Originality",
        "url": "${url}",
        "logo": "${image}",
        "sameAs": [
          "https://wa.me/6281272800800",
          "https://www.instagram.com/originality2016",
          "https://www.tiktok.com/@originality2016"
        ]
      }
      `}</script>

      {/* Fonts */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="true"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Inter:wght@100;200;300;400;500;600;700;800;900&family=Amatic+SC:wght@400;700&display=swap"
        rel="stylesheet"
      />

      {/* Vendor CSS Files */}
      <link
        href="/assets/vendor/bootstrap/css/bootstrap.min.css"
        rel="stylesheet"
      />
      <link
        href="/assets/vendor/bootstrap-icons/bootstrap-icons.css"
        rel="stylesheet"
      />
      <link href="/assets/vendor/aos/aos.css" rel="stylesheet" />
      <link
        href="/assets/vendor/glightbox/css/glightbox.min.css"
        rel="stylesheet"
      />
      <link
        href="/assets/vendor/swiper/swiper-bundle.min.css"
        rel="stylesheet"
      />

      {/* Main CSS Files */}
      <link href="/assets/css/main.css" rel="stylesheet" />
      <link href="/assets/css/originality.css" rel="stylesheet" />
    </Helmet>
  );
};

export default MetaTags;
